//  Mobile Actual status and 0-disconnected, 2-suspended and others -idle
export enum MOBILE_TEXT_STATUS {
  NetTest_None = 0,
  NetTest_PhoneIdle,
  NetTest_PhoneSuspended,
  NetTest_Starting,
  NetTest_TestStarted,
  NetTest_TestInProgress,//5
  NetTest_TestCompleted,
  NetTest_TestResults,
  NetTest_TestStopped,
  NetTest_TestFailed,
  NetTest_TestStopping,
  NetTest_PhoneIdleEmailAuto,
  NetTest_PhoneIdleSMSAuto,
  NetTest_PhoneSuspendedEmailAuto,
  NetTest_PhoneSuspendedSMSAuto,
  NetTest_AirPlaneMode,
  NetTest_PhoneAcceptingRequest, //Old
  NetTest_Started,
  NetTest_Running//18
}

//https://stackoverflow.com/questions/43100718/typescript-enum-to-object-array
export enum DEVICE_CALL_STATUS {
  Idle = 0,   // Gray with text as Idle Over it

  Placing,  // Orange with text as Placing.. Over it
  Placing_RecvDialTone,     //DuFxo after received dial tone
  Placing_DigitsSent,          //DuFxo after Send digits

  RingBack,  // Orange with text as RingBack Over it
  Incoming,  // Violet with text as Incoming Over it
  Answering,  // Violet with text as Answering Over it
  Connected,  // Yellow with text as Connected Over it
  Disconnecting,               //DuFxo after disconnect call    // Gray with text as Disconnecting.. Over it
  Max_Call_Status
}
